import { Link } from "react-router-dom";

const FEATURED = {
  tag: "Cephe Kaplama",
  location: "Osmaniye · 2025",
  title: "Kurumsal Cephe Kaplama Projesi",
  img: "/images/d/d-5.webp",
};

const GRID_3 = [
  {
    tag: "Totem Tabela",
    location: "Osmaniye · 2025",
    title: "Cadde Tipi Totem Uygulaması",
    img: "/images/totemt/2.webp",
  },
  {
    tag: "LED Teknolojisi",
    location: "Osmaniye · 2025",
    title: "LED Cephe Aydınlatma Uygulaması",
    img: "/images/led/3.webp",
  },
  {
    tag: "Dekorasyon",
    location: "Osmaniye · 2025",
    title: "Cafe Konsept İç Mekan Projesi",
    img: "/images/cafe/c (3).webp",
  },
];

const GRID_2 = [
  {
    tag: "Cephe Kaplama",
    location: "Osmaniye · 2025",
    title: "Modern Dış Cephe Kaplama Detayı",
    img: "/images/d/d-10.webp",
  },
  {
    tag: "Matbaa / Baskı",
    location: "Osmaniye · 2025",
    title: "Kurumsal Branda Baskı Uygulaması",
    img: "/images/mat/m-1.webp",
  },
];

const ProjectsSection = () => (
  <section className="py-28 bg-[#F7F7F7]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <div className="anim-left">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
              Portföy
            </span>
          </div>
          <h2 className="font-head font-black uppercase text-[#0D0D0D] text-6xl md:text-7xl leading-[0.9]">
            Projelerimiz
          </h2>
        </div>
        <Link
          to="/projeler"
          className="inline-flex items-center gap-2 font-head font-700 uppercase tracking-wider text-xs text-[#737373] hover:text-[#E6A800] tr cursor-pointer whitespace-nowrap anim-right d2 group"
        >
          Tümünü Gör
          <i className="ri-arrow-right-line group-hover:translate-x-1 tr" />
        </Link>
      </div>

      {/* Featured project */}
      <Link
        to="/projeler"
        className="block relative overflow-hidden w-full mb-3 cursor-pointer anim-up group h-[360px] md:h-[440px]"
      >
        <img
          alt={FEATURED.title}
          className="w-full h-full object-cover object-center tr group-hover:scale-105"
          src={FEATURED.img}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D]/80 via-[#0D0D0D]/30 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/60 via-transparent to-transparent" />
        <div className="absolute top-6 left-6 text-white text-[10px] font-head font-700 uppercase tracking-widest px-3 py-1.5 tr bg-white/15 border border-white/20">
          {FEATURED.tag}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-8 flex items-end justify-between gap-8">
          <div className="tr">
            <p className="text-white/50 text-xs font-head uppercase tracking-wider mb-2">
              {FEATURED.location}
            </p>
            <h3 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9]">
              {FEATURED.title}
            </h3>
          </div>
          <div className="w-12 h-12 flex items-center justify-center shrink-0 tr bg-white/10 text-white/60 group-hover:bg-[#E6A800] group-hover:text-white">
            <i className="ri-arrow-right-up-line text-lg" />
          </div>
        </div>
        <div className="absolute bottom-0 left-0 h-[4px] bg-[#E6A800] tr w-20 group-hover:w-full" />
      </Link>

      {/* 3-column grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        {GRID_3.map((p) => (
          <Link
            key={p.title}
            to="/projeler"
            className="block relative overflow-hidden cursor-pointer anim-up group h-[220px]"
          >
            <img
              alt={p.title}
              className="w-full h-full object-cover object-center tr group-hover:scale-105"
              src={p.img}
            />
            <div className="absolute inset-0 tr bg-[#0D0D0D]/55" />
            <div className="absolute inset-0 p-5 flex flex-col justify-between">
              <span className="self-start text-[9px] font-head font-700 uppercase tracking-wider px-2.5 py-1 tr bg-white/10 text-white/80">
                {p.tag}
              </span>
              <div className="tr">
                <p className="text-white/50 text-[10px] font-head uppercase tracking-wider mb-1">
                  {p.location}
                </p>
                <h3 className="font-head font-bold uppercase text-white text-xl leading-tight">
                  {p.title}
                </h3>
              </div>
            </div>
            <div className="absolute bottom-0 left-0 h-[3px] bg-[#E6A800] tr w-0 group-hover:w-full" />
          </Link>
        ))}
      </div>

      {/* 2-column grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {GRID_2.map((p) => (
          <Link
            key={p.title}
            to="/projeler"
            className="block relative overflow-hidden cursor-pointer anim-up group h-[240px]"
          >
            <img
              alt={p.title}
              className="w-full h-full object-cover object-center tr group-hover:scale-105"
              src={p.img}
            />
            <div className="absolute inset-0 tr bg-[#0D0D0D]/50" />
            <div className="absolute inset-0 p-6 flex flex-col justify-between">
              <span className="self-start text-[9px] font-head font-700 uppercase tracking-wider px-2.5 py-1 tr bg-white/10 text-white/80">
                {p.tag}
              </span>
              <div className="flex items-end justify-between tr">
                <div>
                  <p className="text-white/50 text-[10px] font-head uppercase tracking-wider mb-1">
                    {p.location}
                  </p>
                  <h3 className="font-head font-black uppercase text-white text-2xl leading-tight">
                    {p.title}
                  </h3>
                </div>
                <div className="w-10 h-10 flex items-center justify-center shrink-0 tr ml-4 bg-white/10 text-white/40 group-hover:bg-[#E6A800] group-hover:text-white">
                  <i className="ri-arrow-right-up-line text-sm" />
                </div>
              </div>
            </div>
            <div className="absolute bottom-0 left-0 h-[3px] bg-[#E6A800] tr w-0 group-hover:w-full" />
          </Link>
        ))}
      </div>

      <div className="mt-8 flex items-center justify-between anim-up d6">
        <span className="text-[#737373] text-xs font-head uppercase tracking-wider">
          1577+ tamamlanan proje
        </span>
        <Link
          to="/projeler"
          className="inline-flex items-center gap-2 px-6 py-3 btn-red font-head font-700 uppercase tracking-wider text-xs cursor-pointer whitespace-nowrap"
        >
          Tüm Projeler
          <i className="ri-arrow-right-line text-xs" />
        </Link>
      </div>
    </div>
  </section>
);

export default ProjectsSection;